import Banner from "../../images/banner.jpg";
import "./CookieNotice.css";
import Footer from "../Footer/Footer";
import NavBar from "../Layout/NavBar";

const CookieNotice = () => {
  const year = new Date().getFullYear();

  return (
    <div className="cookie-home">
      {/* Banner */}
      <div className="cookie-banner">
        <img src={Banner} alt="Cookie Banner" />
      </div>

      <NavBar />

      <div className="cookie-container">
        <h1>Cookie Notice</h1>
        <p className="updated-date">Last updated: {year}</p>

        <section>
          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a
            website. They help websites function properly, remember preferences,
            and analyze how visitors interact with the site.
          </p>
        </section>

        <section>
          <h2>How We Use Cookies</h2>
          <p>Flickerbound uses cookies to:</p>
          <ul>
            <li>Improve website performance</li>
            <li>Remember your preferences</li>
            <li>Analyze traffic and usage patterns</li>
            <li>Support essential site functionality</li>
          </ul>
          <p>
            These cookies help ensure a smooth and personalized browsing
            experience.
          </p>
        </section>

        <section>
          <h2>Types of Cookies We Use</h2>

          <h3>1. Essential Cookies</h3>
          <p>
            Required for the website to function. These cookies enable basic
            features such as page navigation and secure access.
          </p>

          <h3>2. Performance & Analytics Cookies</h3>
          <p>
            These cookies help us understand how visitors use the site so we can
            improve layout, content, and functionality.
          </p>

          <h3>3. Preference Cookies</h3>
          <p>
            These remember your settings and choices, such as language or
            display preferences.
          </p>
        </section>

        <section>
          <h2>Third‑Party Cookies</h2>
          <p>
            Some cookies may come from third‑party services such as analytics
            tools or embedded content. These providers may collect data according
            to their own privacy policies.
          </p>
        </section>

        <section>
          <h2>Managing Cookies</h2>
          <p>
            You can control or disable cookies through your browser settings.
            Please note that disabling certain cookies may affect website
            functionality.
          </p>
        </section>

        <section>
          <h2>Updates to This Notice</h2>
          <p>
            We may update this Cookie Notice periodically. The “Last updated”
            date will always reflect the most recent version.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have questions about this Cookie Notice, you can reach us at:</p>
          <p>
            <strong>https://flickerbound.com/contact</strong>
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default CookieNotice;
